import * as React from 'react';

import * as styles from './styles.css';

export interface IMainPinProps {
  title: string;
}

/** Пин ЖК — центр карты района. Каплевидный пин как на карте инфраструктуры в map-search. */
export function MainPin({ title }: IMainPinProps): React.JSX.Element {
  return <div className={styles['pin']} data-testid="district-infrastructure-map-main-pin" title={title} />;
}
